export default function BreadcrumbModel(name, isLink = false, to) {
  this.Name = name
  this.IsLink = isLink

  if (this.IsLink) {
    this.LinkTo = to
  }
}
